<template>
  <div>       
       <div class="row">   
        <div class="col-xs-1 col-md-1" >                        
        </div>
        <div class="col-xs-10 col-md-10" > 
            <router-view></router-view>                       
        </div>
        <div class="col-xs-1 col-md-1" >                   
        </div>
      </div>
  </div>
</template>

<script>
import { eventBus } from '../../main';
export default {  
  data: function () {     
    return {
       
    }
  },
  mounted: function () {        

  },
  methods: {
    
  },
  filters: {
     
  },
  computed: {
    
  }
}
</script>

<style>
 
</style>



// WEBPACK FOOTER //
// Generic.vue?35718828